import type {
  EmailSnippet,
  EmailSnippetInput,
  EmailTemplate,
  EmailTemplateInput,
} from "@sales-ops-amplify/shared";
import { apiDelete, apiGet, apiPatch, apiPost } from "./client";

export function listEmailTemplates(): Promise<{ templates: EmailTemplate[] }> {
  return apiGet("/api/email-templates");
}

export function createEmailTemplate(
  input: EmailTemplateInput,
): Promise<{ template: EmailTemplate }> {
  return apiPost("/api/email-templates", input);
}

export function updateEmailTemplate(
  templateId: string,
  input: Partial<EmailTemplateInput>,
): Promise<{ template: EmailTemplate }> {
  return apiPatch(`/api/email-templates/${templateId}`, input);
}

export function deleteEmailTemplate(
  templateId: string,
): Promise<{ deleted: boolean }> {
  return apiDelete(`/api/email-templates/${templateId}`);
}

export function listEmailSnippets(): Promise<{ snippets: EmailSnippet[] }> {
  return apiGet("/api/email-snippets");
}

export function createEmailSnippet(
  input: EmailSnippetInput,
): Promise<{ snippet: EmailSnippet }> {
  return apiPost("/api/email-snippets", input);
}

export function updateEmailSnippet(
  snippetId: string,
  input: Partial<EmailSnippetInput>,
): Promise<{ snippet: EmailSnippet }> {
  return apiPatch(`/api/email-snippets/${snippetId}`, input);
}

export function deleteEmailSnippet(
  snippetId: string,
): Promise<{ deleted: boolean }> {
  return apiDelete(`/api/email-snippets/${snippetId}`);
}
